import React, { useEffect, useState } from "react";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "./BuyConfirm.module.scss";
import Select from "../../Formik/Select/Select";
import { useSelector } from "react-redux";
import { formatPrice, toFix } from "../../../../utils/utils";
import ErrorText from "../../Formik/ErrorText/ErrorText";
import { PAYMENTMETHODS } from "../../../../utils/constants";

const BuyConfirm = ({
  show,
  handleClose,
  handleBuyConfirm,
  buyData,
  setPaymentType,
  title,
}) => {
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  // const walletBalance = useSelector((state) => state?.users?.walletBalance);
  const commonWalletBalance = useSelector(
    (state) => state?.users?.commonWalletBalance
  );

  // const [balanceObj, setBalanceObj] = useState({});
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(
    PAYMENTMETHODS[0]
  );
  const [balanceError, setBalanceError] = useState("");

  const handlePaymentModeChange = (selectedOption) => {
    setSelectedPaymentMode(selectedOption);
    setPaymentType(selectedOption?.label);
  };

  useEffect(() => {
    if (show) {
      // const selectedWalletBalance = balanceObj[selectedPaymentMode?.label];
      const totalOrderAmount =
        Number(buyData.quantity) * Number(buyData.amount);
      setBalanceError("");
      if (Number(commonWalletBalance.amount) < totalOrderAmount) {
        setBalanceError(
          "Insufficient wallet balance. Please add funds to your wallet."
        );
        return;
      }
    }
  }, [selectedPaymentMode, show]);

  useEffect(() => {
    setSelectedPaymentMode(PAYMENTMETHODS[0]);
  }, [show]);

  // useEffect(() => {
  //   if (show) {
  //     buyData.price =
  //       buyData.tokenName === "Gold STBL"
  //         ? spot?.goldPrice
  //         : spotPrice?.silverPrice;
  //   }
  // }, [spotPrice, show]);

  // useEffect(() => {
  //   let data = [];
  //   walletBalance.length > 0 &&
  //     walletBalance?.forEach((element) => {
  //       data[element.account_type] = element.amount;
  //     });
  //   setBalanceObj(data);
  // }, [walletBalance]);

  return (
    <>
      <Modal
        className={styles.buy_modal}
        show={show}
        handleClose={() => {
          handleClose();
          setBalanceError("");
        }}
        title={title}
      >
        <ul>
          <li>
            <h6>Quantity (Ozt)</h6>
            <h4>{buyData?.quantity}</h4>
          </li>
          <li>
            <h6>At Price</h6>
            <h4>${formatPrice(Number(buyData?.amount))}</h4>
          </li>
          <li>
            <h6>Total</h6>
            <h4>${formatPrice(Number(buyData?.quantity * buyData?.amount))}</h4>
          </li>

          {/* <li>
            <h6>Select Method</h6>
            <Select
              variant="dark"
              placeholder={<h6>Select</h6>}
              isSearchable={false}
              className={styles.select}
              options={PAYMENTMETHODS}
              defaultValue={PAYMENTMETHODS[0]}
              onChange={handlePaymentModeChange}
            />
          </li> */}
          <li>
            <h6 className={styles.balance}>STBL Wallet Bal: </h6>
            <h4> ${toFix(commonWalletBalance?.amount, 3)}</h4>
          </li>
          <li>{balanceError && <ErrorText>{balanceError}</ErrorText>}</li>
        </ul>
        <Button
          fluid
          variant="secondary_btn"
          className={styles.submit_btn}
          onClick={handleBuyConfirm}
          disabled={balanceError}
        >
          Confirm Buy
        </Button>
      </Modal>
    </>
  );
};

export default BuyConfirm;
